import { Type } from 'class-transformer';
import { Model } from './model';
import { Partner } from './partner';
import { Invoice } from './invoice';

export enum CheckoutSessionStatus {
  OPEN = 'open',
  COMPLETE = 'complete',
  EXPIRED = 'expired',
}

export class CheckoutSession extends Model {
  id: string;

  @Type(() => Invoice)
  invoices: Invoice[];

  @Type(() => Partner)
  partner: Partner;

  customer_email: string;

  status: CheckoutSessionStatus;

  stripe_connected_account_id: string;
}
